/** Subprotocol marker for connect-time secrets (bridge token, Zoom app context). */
export const ZCS_WS_AUTH_PROTOCOL = 'zcs-auth-v1';
const AUTH_PREFIX = `${ZCS_WS_AUTH_PROTOCOL}.`;
function base64UrlEncodeUtf8(text) {
    const bytes = new TextEncoder().encode(text);
    let binary = '';
    for (const byte of bytes) {
        binary += String.fromCharCode(byte);
    }
    const b64 = btoa(binary);
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function base64UrlDecodeUtf8(encoded) {
    if (!encoded || !/^[A-Za-z0-9_-]+$/.test(encoded))
        return undefined;
    const padLen = (4 - (encoded.length % 4)) % 4;
    const padded = encoded.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat(padLen);
    try {
        const binary = atob(padded);
        const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
        return new TextDecoder().decode(bytes);
    }
    catch {
        return undefined;
    }
}
/** Encode a connect secret for `Sec-WebSocket-Protocol` (not the URL). */
export function encodeWsConnectSecret(secret) {
    return `${AUTH_PREFIX}${base64UrlEncodeUtf8(secret)}`;
}
/** Decode a connect secret from the `Sec-WebSocket-Protocol` header value. */
export function decodeWsConnectSecret(secWebSocketProtocol) {
    if (!secWebSocketProtocol?.trim())
        return undefined;
    for (const part of secWebSocketProtocol.split(',')) {
        const token = part.trim();
        if (!token.startsWith(AUTH_PREFIX))
            continue;
        const payload = token.slice(AUTH_PREFIX.length);
        const decoded = base64UrlDecodeUtf8(payload);
        if (decoded !== undefined)
            return decoded;
    }
    return undefined;
}
//# sourceMappingURL=ws-connect-auth.js.map